'use strict';

var toastr = require('toastr');
var SystemStatusFaresReoptController = function SystemStatusFaresReoptController($scope, reoptimizationService, systemStatusCommonRendererFactory, $q, $state, $log) {
  function postColumnsSuccessHandler() {
    toastr.success('Successfully saved configuration changes.');
  }
  function postColumnsErrorHandler(response) {
    var errorMsg = 'Error when saving configuration changes. ' + response.statusText + ' (code ' + response.status + ')';
    $log.error('SystemStatusDemandReinitializationController: postColumnsErrorHandler - ' + errorMsg);
    toastr.error(errorMsg);
    return $q.reject();
  }
  function reloadData() {
    $scope.$broadcast('grid:dataChanged');
  }
  $scope.reoptimize = function (event, rows) {
    reoptimizationService.reoptimizeFaresFromStatusScreen(rows).then(postColumnsSuccessHandler, postColumnsErrorHandler).then(reloadData);
  };
  $scope.customRenderers = systemStatusCommonRendererFactory;
};
SystemStatusFaresReoptController.$inject = ['$scope', 'ReoptimizationService', 'SystemStatusCommonRendererFactory', '$q', '$state', '$log'];
module.exports = SystemStatusFaresReoptController;